import React from "react";

import {breadcrumbNameMap} from "../Constants";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

export default function RelevantLinkBlock({relevantUrls}) {

    return <div className="row">
            <div className="col ml-auto">
                <div className="bg-white p-3 p-md-5">
                    <h4 className="text-black mb-4">Релевантные ссылки</h4>

                    {relevantUrls.map(url => {
                        let breadcrumbName = url.includes("?") ? url.slice(0, url.lastIndexOf('?')) : url;

                        return (
                        <ListItem disableGutters={true}>
                            <ListItemButton component="a" href={url} color="primary" disableGutters={true}>
                                <ListItemText
                                    primary={breadcrumbNameMap[breadcrumbName].title}
                                    secondary={breadcrumbNameMap[breadcrumbName].description}
                                />
                            </ListItemButton>
                        </ListItem>
                    )})}

                </div>
            </div>
        </div>;
}